import React from "react";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

function LegalItem({ number, children }) {
  return (
    <div className="legal-item">
      <span className="legal-item-number">{number}</span>

      <div className="legal-item-content">
        {children}
      </div>
    </div>
  );
}

function SubTitle({ children }) {
  return (
    <h3 className="legal-subtitle">
      {children}
    </h3>
  );
}

export default function PrivacyPolicy() {
  return (
    <main className="legal-page">
      <style>{styles}</style>

      <SiteHeader />

      {/* =====================================================
          PAGE TITLE
         ===================================================== */}

      <header className="legal-header">
        <div className="legal-wrap">
          <h1>隱私權政策</h1>
        </div>
      </header>

      {/* =====================================================
          CONTENT
         ===================================================== */}

      <div className="legal-wrap legal-layout">
        <article className="legal-content">

          {/* =====================================================
              第一條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第一條</span>

              <h2>
                適用範圍及資料蒐集者
              </h2>
            </div>

            <LegalItem number="一、">
              <p>
                本使用條款適用於您使用 TALLARGE
                提供的任何相關軟體、應用程式、網站及其他相關服務（以下統稱「本服務」）。
              </p>
            </LegalItem>

            <LegalItem number="二、">
              <p>
                TALLARGE 是由 張庭瑋 及 陳 煜
                共同經營並提供相關服務的品牌。本政策所稱「TALLARGE」、「我們」或「本服務提供者」，均指前述實際經營者。當您註冊、登入、下載或開始使用本服務，即表示您已閱讀、瞭解並同意遵守本政策。
              </p>
            </LegalItem>
          </section>

          {/* =====================================================
              第二條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第二條</span>

              <h2>
                我們蒐集的個人資料
              </h2>
            </div>

            <p className="legal-lead">
              我們依使用者身分、帳號權限、啟用功能及實際操作情形，
              蒐集下列敘述之資料。使用者上傳任何資料前，
              應確認具有合法權利、授權或其他適法依據。
            </p>

            <SubTitle>
              一、使用者或企業客戶提供的資料
            </SubTitle>

            <LegalItem number="（一）">
              <div>
                <strong>
                  帳號及基本資料
                </strong>

                <p>
                  當使用者註冊、啟用帳號、編輯個人資料，
                  或由所屬企業之管理人員建立其帳號、人員、
                  車輛或車隊資料時，我們會蒐集姓名、聯絡電話、
                  電子郵件、頭像、員工或司機編號、所屬企業、
                  部門、職務、帳號角色、使用權限及登入驗證資料，
                  亦會蒐集所屬車隊分類、工作狀態、車牌號碼、
                  車型、車輛基本資料、車輛狀態、里程數、
                  設備狀態、使用狀態、保養及維修資料，
                  以及人員與車輛、車隊或工作任務間的指派關係。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="（二）">
              <div>
                <strong>
                  關於任務執行之資料
                </strong>

                <p>
                  管理人員建立、安排或指派工作任務，
                  或使用者接收、執行及回報任務時，
                  我們會蒐集任務名稱、工作內容、客戶資訊、
                  聯絡方式、取貨地址、送貨地址、貨物資訊、
                  貨物照片、指派車輛與司機、預定或實際作業時間、
                  任務進度、完成狀態、取消或異常原因及備註。
                  使用者拍攝、上傳照片或辦理電子簽收時，
                  我們亦會蒐集其提供的工作照片、電子簽名、
                  簽收人資料、上傳或簽收時間，
                  以及經使用者授權取得的定位資料。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="（六）">
              <div>
                <strong>
                  行車前檢查及異常事件資料
                </strong>

                <p>
                  司機須於每日工作前進行當日行車前檢查及酒測，
                  或於出車前、行駛途中回報車輛、
                  設備或其他營運異常時，
                  我們會蒐集其填寫及上傳的報表記錄、
                  車輛及設備狀況、司機每日酒測數值資料及佐證照片、
                  車輛故障、事故、延誤、貨損或其他營運異常之內容或備註、
                  發生時間、地點、處理情形、異常照片及相關回報資料。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="（七）">
              <div>
                <strong>
                  費用與支出
                </strong>

                <p>
                  使用者填寫加油紀錄或申報業務支出時，
                  我們會蒐集加油時間與地點、油品、油量、
                  加油前里程數、金額、申報人、加油備註及上傳的收據或憑證影像；
                  使用者申報停車、通行、維修、保養、
                  耗材或其他營運費用時，
                  我們會蒐集支出日期、費用項目、金額、
                  備註及上傳的收據或憑證影像。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="（八）">
              <div>
                <strong>
                  內部訊息
                </strong>

                <p>
                  當使用者利用本服務內建的訊息功能與其他使用者
                  單獨對話或群組對話，我們可能會蒐集包括聊天室訊息、
                  聯絡人資料、通知內容、聊天內圖片，
                  以及使用者提供的相關附件。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="（九）">
              <div>
                <strong>
                  通聯資訊
                </strong>

                <p>
                  如果您透過表單、電子郵件、電話或其他通訊管道
                  與 TALLARGE 聯繫，我們將依據您的互動需求，
                  蒐集您的姓名、電話號碼、電子郵件、通訊地址、
                  IP 位址、對話紀錄、留言內容、諮詢項目、客訴原因。
                </p>
              </div>
            </LegalItem>

            <SubTitle>
              二、使用本服務時產生的資料
            </SubTitle>

            <LegalItem number="（一）">
              <div>
                <strong>
                  使用者操作及使用資料
                </strong>

                <p>
                  使用者登入、瀏覽或操作本服務時，
                  系統將依實際使用情形，
                  記錄與帳號相關之登入及登出時間、功能存取、
                  頁面瀏覽、點擊、查詢、搜尋、篩選、排序、
                  上傳、下載及匯出等使用歷程；
                  使用者建立、指派、調整、完成、
                  取消或刪除工作任務，或新增、修改、送出、
                  審核、核准、退回或刪除人員、車輛、
                  行車前檢查、異常事件、費用及其他營運資料時，
                  系統亦會留存執行操作之帳號、操作時間、
                  異動事項、處理結果及相關紀錄，
                  以供資訊安全、故障排除及爭議處理之用。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="（二）">
              <div>
                <strong>
                  裝置資料及裝置權限
                </strong>

                <p>
                  使用者透過應用程式或網頁版介面登入或使用本服務時，
                  系統將蒐集並記錄 IP 位址、裝置廠牌、
                  型號與類型、作業系統及版本、瀏覽器類型與版本、
                  應用程式版本、語言、時區及網路連線狀態。
                  為完成帳號驗證、資料傳輸及推播通知，
                  系統亦會記錄使用者帳號識別資訊、
                  應用程式識別碼、安裝識別碼、推播權杖、
                  連線或服務請求時間及相關處理紀錄。
                </p>

                <p>
                  為提供定位、任務追蹤、拍照上傳、
                  電子簽收、異常回報及推播通知等功能，
                  本服務可能透過裝置作業系統請求定位、
                  相機、相簿、通知或其他必要之裝置權限。
                  使用者完成授權並使用相關功能時，
                  我們將依實際啟用之功能及授權範圍，
                  蒐集 GPS 座標、定位時間、移動軌跡、
                  停留地點、行程資料，以及使用者拍攝、
                  選取或上傳之照片、影像與附件，
                  並處理推播通知所需之識別資訊。
                  我們不會因取得前述權限，
                  而任意存取裝置內與本服務無關之資料。
                </p>
              </div>
            </LegalItem>

            <SubTitle>
              四、由其他來源取得的資料
            </SubTitle>

            <p className="legal-body-paragraph">
              我們可能自使用者所屬企業、管理員帳號、
              其他經授權使用者、受託服務供應商或依法有權提供資料之機關，
              取得提供本服務所需之資料。
              使用者於聯絡客服、申請技術支援、
              進行身分或使用資格驗證、參與活動或問卷調查，
              以及提出意見或申訴時，
              我們亦可能蒐集使用者主動提供之相關資料。
            </p>
          </section>

          {/* =====================================================
              第三條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第三條</span>

              <h2>
                我們如何使用個人資料
              </h2>
            </div>

            <p className="legal-lead">
              TALLARGE 於下列必要範圍內處理及利用個人資料：
            </p>

            <LegalItem number="（一）">
              <p>
                建立、驗證及管理使用者帳號，
                確認使用者身分、所屬企業、
                帳號角色與使用權限，
                並提供登入及帳號安全功能。
              </p>
            </LegalItem>

            <LegalItem number="（二）">
              <p>
                用於儲存、處理及同步使用者透過本服務輸入、
                上傳或產生之資料，使相關資料得依帳號權限於管理員、
                司機及其他授權使用者之裝置間顯示、
                更新、查詢及匯出。
              </p>
            </LegalItem>

            <LegalItem number="（四）">
              <p>
                傳送任務指派、工作進度、異常事件、
                帳號安全、系統維護、軟體更新及其他
                與本服務有關之必要通知。
              </p>
            </LegalItem>

            <LegalItem number="（五）">
              <p>
                提供客服進行身分確認、
                故障排除、爭議處理及技術支援。
              </p>
            </LegalItem>

            <LegalItem number="（六）">
              <p>
                進行資料備份、災難復原及資安監控，
                偵測並防止異常登入、詐欺、濫用、
                惡意攻擊、未經授權存取或其他違法行為，
                以維護本服務、使用者及相關資料之安全。
              </p>
            </LegalItem>

            <LegalItem number="（七）">
              <p>
                記錄使用者之顯示方式、通知設定、
                常用操作及其他操作偏好，
                並依帳號角色、使用權限及服務方案
                提供相應之操作介面與功能。
              </p>
            </LegalItem>

            <LegalItem number="（八）">
              <p>
                分析功能使用情形、操作流程、
                系統效能、錯誤紀錄及當機資訊，
                用於排除故障、修正錯誤、改善操作介面、
                提升服務效能，以及規劃或開發新功能。
              </p>
            </LegalItem>

            <LegalItem number="（九）">
              <p>
                於必要範圍內使用相關資料，
                以遵守法令、主管機關要求、
                法院命令或其他合法程序，
                以及建立、行使或維護法律上之權利。
              </p>
            </LegalItem>

            <LegalItem number="（十）">
              <p>
                我們得於具有合法依據並完成必要程序之範圍內，
                將相關數據進行匿名化或彙整，
                製成˙直接或間接識別特定自然人或企業之統計及分析成果，
                用於服務改善、產品規劃、產業研究、
                商業合作、對外提供或販售。
              </p>
            </LegalItem>
          </section>

          {/* =====================================================
              第四條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第四條</span>

              <h2>
                如何保存及保護個人資料
              </h2>
            </div>

            <LegalItem number="一、">
              <div>
                <strong>
                  傳輸與儲存安全
                </strong>

                <p>
                  我們將依資料性質及風險，
                  採取商業上合理之技術、管理及組織措施，
                  包括存取權限控管、身分驗證、
                  傳輸或儲存保護、備份、紀錄保存、
                  安全監控及受託廠商管理，
                  以防止資料遭未經授權之存取、
                  使用、洩漏、竄改、毀損或滅失。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="二、">
              <div>
                <strong>
                  權限控管
                </strong>

                <p>
                  僅限因提供、維護或保護本服務而有必要之人員
                  及服務供應商，得於其職務及授權範圍內存取資料。
                  但任何網路傳輸或儲存方式均無法保證絕對安全，
                  使用者亦應妥善保管帳號、密碼、
                  裝置及匯出資料。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="三、">
              <div>
                <strong>
                  資料保存期間將依下列因素決定：
                </strong>

                <div className="legal-nested-list">
                  <p>
                    （一）提供本服務及完成蒐集目的所需期間。
                  </p>

                  <p>
                    （二）資料之性質、敏感程度及未經授權使用可能造成之風險。
                  </p>

                  <p>
                    （三）企業客戶與 TALLARGE 之契約關係。
                  </p>

                  <p>
                    （四）適用法令、會計、稅務、爭議處理、
                    資安及其他必要保存要求。
                  </p>
                </div>
              </div>
            </LegalItem>

            <LegalItem number="四、">
              <div>
                <strong>
                  終止服務
                </strong>

                <p>
                  使用者帳號停用或所屬企業之服務契約終止後，
                  TALLARGE 提供自終止生效日起三十日之資料匯出期間。
                  使用者僅得在原授權範圍內登入並查詢及匯出資料，
                  不因匯出期間而恢復其他功能或擴大資料權限。
                </p>

                <p>
                  前述期間屆滿後，TALLARGE
                  得依適用法令刪除或匿名化相關資料；
                  依法須保存，或為爭議處理、
                  資安調查及權利主張所必要者，
                  得於必要期間內限制保存及利用。
                  備份資料將依既定備份週期逐步覆寫或刪除。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="五、">
              <div>
                <strong>
                  個人資料事件之應變
                </strong>

                <p>
                  TALLARGE 知悉個人資料遭竊取、
                  竄改、毀損、滅失或洩漏時，
                  將採取合理必要之應變措施，
                  防止影響擴大，並依法辦理通知及通報。
                </p>
              </div>
            </LegalItem>
          </section>

          {/* =====================================================
              第五條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第五條</span>

              <h2>
                何時會提供或揭露個人資料
              </h2>
            </div>

            <p className="legal-lead">
              TALLARGE 僅於下列情形及必要範圍內提供或揭露個人資料：
            </p>

            <LegalItem number="一、">
              <div>
                <strong>
                  第三方服務供應商
                </strong>

                <p>
                  我們得委託雲端主機、資料庫、儲存、
                  地圖、定位、路線規劃、推播、簡訊、
                  電子郵件、客服、資安、分析及其他技術服務供應商處理資料。
                  該等供應商僅得依我們的指示處理必要之範圍資料。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="二、">
              <div>
                <strong>
                  法律及安全需要
                </strong>

                <p>
                  為遵守法令、法院命令、
                  主管機關或執法機關之合法要求，
                  或為調查違法、詐欺、侵權、
                  資安事件及使用條款違規，
                  或為保護 TALLARGE、使用者、
                  第三人或公眾之權利、財產與安全所必要時，
                  得依法提供相關資料。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="三、">
              <div>
                <strong>
                  營運或服務移轉
                </strong>

                <p>
                  當 TALLARGE 發生組織調整、合併、
                  合作、資產或業務移轉、經營者變更，
                  或將本服務移轉予其他經營者時，
                  得於合法且必要之範圍內，
                  向參與評估、交易及承接服務之對象
                  提供或移轉相關資料，
                  並要求其採取適當保密及安全措施。
                  對使用者權益有重大影響者，
                  TALLARGE 將依法通知。
                </p>
              </div>
            </LegalItem>

            <LegalItem number="四、">
              <div>
                <strong>
                  境外處理及傳輸
                </strong>

                <p>
                  因使用境外第三方服務或其他服務供應商，
                  個人資料可能傳輸或儲存於中華民國境外。
                  TALLARGE 將依法採取必要之契約及安全措施，
                  並遵守主管機關對國際傳輸之限制。
                </p>
              </div>
            </LegalItem>
          </section>

          {/* =====================================================
              第六條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第六條</span>

              <h2>
                使用者的權利及選擇
              </h2>
            </div>

            <LegalItem number="一、">
              <div>
                <p>
                  使用者得依個人資料保護法，
                  就其個人資料行使下列權利：
                </p>

                <div className="legal-nested-list">
                  <p>（一）查詢或請求閱覽。</p>
                  <p>（二）請求製給複製本。</p>
                  <p>（三）請求補充或更正。</p>
                  <p>（四）請求停止蒐集、處理或利用。</p>
                  <p>（五）請求刪除。</p>
                </div>
              </div>
            </LegalItem>

            <LegalItem number="二、">
              <div>
                <strong>
                  提供資料與裝置權限之選擇
                </strong>

                <p>
                  除法令另有規定外，
                  使用者得自由選擇是否提供個人資料，
                  並得隨時透過裝置設定撤回或調整定位、
                  相機、相簿、通知或其他裝置權限。
                  拒絕提供資料、停止提供資料或調整裝置權限，
                  不影響此前已依法完成之資料處理。
                </p>
              </div>
            </LegalItem>
          </section>

          {/* =====================================================
              第七條
             ===================================================== */}

          <section className="legal-section">
            <div className="legal-section-heading">
              <span>第七條</span>

              <h2>
                隱私權政策的變更
              </h2>
            </div>

            <LegalItem number="一、">
              <p>
                我們會因服務調整、技術發展、
                法令變更或個人資料處理方式改變而修訂本政策，
                並更新版本及生效日期。
              </p>
            </LegalItem>

            <LegalItem number="二、">
              <p>
                如本政策修訂事項涉及新增個人資料利用目的，
                或對個人資料之蒐集、利用、揭露
                或使用者權利有重大影響，
                我們將於生效前之合理期間內，
                透過本服務公告、系統推播、
                電子郵件或其他適當方式通知使用者。
              </p>
            </LegalItem>

            <LegalItem number="三、">
              <p>
                除依法須另行取得使用者明確或單獨同意之事項外，
                使用者於修訂後之政策生效後繼續使用本服務，
                即表示已閱讀、瞭解並同意接受修訂後之政策。
              </p>
            </LegalItem>
          </section>

        </article>
      </div>

      <SiteFooter />
    </main>
  );
}

const styles = `
* {
  box-sizing: border-box;
}

.legal-page {
  min-height: 100vh;

  display: flex;
  flex-direction: column;

  background: #fff;

  color: #22272c;

  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "SF Pro Text",
    "SF Pro Display",
    "PingFang TC",
    "Noto Sans TC",
    "Microsoft JhengHei",
    Arial,
    sans-serif;

  -webkit-font-smoothing: antialiased;
}

.legal-wrap {
  width: min(900px, calc(100% - 48px));

  margin: 0 auto;
}


/* =========================================================
   HEADER
   ========================================================= */

.legal-header {
  padding:
    52px 0
    42px;

  border-bottom:
    1px solid #eeeeec;
}

.legal-header h1 {
  margin: 0;

  color: #20252a;

  font-size:
    clamp(
      30px,
      3vw,
      40px
    );

  font-weight: 600;

  line-height: 1.2;

  letter-spacing:
    -.04em;
}


/* =========================================================
   LAYOUT
   ========================================================= */

.legal-layout {
  flex: 1;

  padding:
    58px 0
    100px;
}

.legal-content {
  width: 100%;
}


/* =========================================================
   SECTION
   ========================================================= */

.legal-section {
  padding-bottom: 62px;

  margin-bottom: 62px;

  border-bottom:
    1px solid #eeeeec;
}

.legal-section-heading {
  margin-bottom: 30px;
}

.legal-section-heading > span {
  display: block;

  margin-bottom: 8px;

  color: #555c62;

  font-size: 12px;

  font-weight: 500;
}

.legal-section-heading h2 {
  margin: 0;

  color: #22272c;

  font-size:
    clamp(
      22px,
      2vw,
      28px
    );

  font-weight: 600;

  line-height: 1.4;

  letter-spacing:
    -.025em;
}

.legal-lead,
.legal-body-paragraph {
  margin:
    0 0
    28px;

  color: #555d64;

  font-size: 14px;

  line-height: 2;
}


/* =========================================================
   SUBTITLE
   ========================================================= */

.legal-subtitle {
  margin:
    38px 0
    19px;

  color: #30363b;

  font-size: 16px;

  font-weight: 600;

  line-height: 1.6;
}


/* =========================================================
   ITEM
   ========================================================= */

.legal-item {
  display: grid;

  grid-template-columns:
    58px
    minmax(0, 1fr);

  gap: 8px;

  margin-top: 22px;
}

.legal-item-number {
  padding-top: 2px;

  color: #777e84;

  font-size: 13px;

  line-height: 1.95;
}

.legal-item-content {
  min-width: 0;
}

.legal-item-content strong {
  display: block;

  margin-bottom: 5px;

  color: #343a40;

  font-size: 14px;

  font-weight: 600;

  line-height: 1.8;
}

.legal-item-content p {
  margin: 0;

  color: #555d64;

  font-size: 14px;

  line-height: 2;
}

.legal-item-content p + p {
  margin-top: 13px;
}

.legal-nested-list {
  margin-top: 10px;
}

.legal-nested-list p {
  margin:
    5px 0;
}


/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 620px) {
  .legal-wrap {
    width:
      calc(
        100% - 34px
      );
  }

  .legal-header {
    padding:
      38px 0
      30px;
  }

  .legal-header h1 {
    font-size: 29px;
  }

  .legal-layout {
    padding:
      42px 0
      70px;
  }

  .legal-section {
    padding-bottom: 48px;

    margin-bottom: 48px;
  }

  .legal-section-heading {
    margin-bottom: 24px;
  }

  .legal-section-heading h2 {
    font-size: 22px;
  }

  .legal-item {
    grid-template-columns:
      44px
      minmax(0, 1fr);
  }

  .legal-item-content p,
  .legal-lead,
  .legal-body-paragraph {
    font-size: 13px;

    line-height: 1.95;
  }
}
`;